import { NgModule, InjectionToken } from '@angular/core';
import { Platform } from './core/index';
// import { Log }                           from './core/index';
import { AlyleServiceConfig } from './core/alyle-config-service';
import { LyCoreModule } from './core/core';
import { LyPalette, LyTheme } from './core/palette';
export var /** @type {?} */ AUI_VERSION = '1.3.6';
// export
// export * from './button';
// export * from './drawer/index';
// export * from './icon-button/index';
// export * from './toolbar/index';
// export * from './carousel/index';
// export * from './date-picker/index';
// export * from './input/index';
// export * from './radio/index';
// export * from './ripple/index';
// export * from './menu/index';
export { LyResizingCroppingSmallImageModule, ResizingCroppingImagesComponent } from './resizing-cropping-images/index';
export { LY_UPLOAD_CONTROL_VALUE_ACCESSOR, LyUploadFiles, LyUploadFilesModule } from './upload-files/index';
// export * from './ls/index';
// export * from './header-pagination/index';
// export * from './tabs/index';
export { LyShadowModule, LyShadowService, LyDeepComponent } from './shadow/index';
// export * from './svg/index';
export { LyCheckboxModule, LyCheckboxService, LY_CHECKBOX_CONTROL_VALUE_ACCESSOR, CheckboxState, LyCheckbox } from './checkbox/index';
export { hexToRgba, LyTemplate, Color, themeProperty, getColor, LyTheme, BgAndColorStyle, LyStyleTheme, LyPalette, coerceBooleanProperty, coerceNumberProperty, RandomId, Log, Ly_Next, Ly_Prev, InteractivityChecker, getParents, AlyleServiceConfig, LyForceColor, LyRoot, LyInlineText, LyCoreComponent, LyCoreModule, Platform, getSupportedInputTypes } from './core/index';
export { NgTranscludeDirective } from './minimal/index';
/* tslint:disable */
var /** @type {?} */ AlyleServiceConfigToken = new InjectionToken('AlyleServiceConfigToken');
/**
 * @param {?} data
 * @return {?}
 */
export function findColor(data) {
    return LyPalette.colors.find(function (_) { return _.name === data; });
}
/**
 * @param {?} _color
 * @return {?}
 */
export function _paletteFactory(_color) {
    return new LyTheme(_color);
}
/* tslint:disable */
export var /** @type {?} */ AlyleUIProvider = {
    provide: LyTheme,
    useFactory: _paletteFactory,
    deps: [AlyleServiceConfigToken]
};
var AlyleUIModule = (function () {
    function AlyleUIModule() {
    }
    /**
     * @param {?} config
     * @return {?}
     */
    AlyleUIModule.forRoot = function (config) {
        return {
            ngModule: AlyleUIModule,
            providers: [
                { provide: AlyleServiceConfig, useValue: config },
            ],
        };
    };
    return AlyleUIModule;
}());
export { AlyleUIModule };
AlyleUIModule.decorators = [
    { type: NgModule, args: [{
                imports: [LyCoreModule.forRoot()],
                exports: [LyCoreModule],
                providers: [
                    LyTheme,
                    // AlyleUIProvider,
                    Platform,
                    LyPalette
                ]
            },] },
];
/**
 * @nocollapse
 */
AlyleUIModule.ctorParameters = function () { return []; };
function AlyleUIModule_tsickle_Closure_declarations() {
    /** @type {?} */
    AlyleUIModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AlyleUIModule.ctorParameters;
}
export { AlyleServiceConfigToken };



//////////////////
// WEBPACK FOOTER
// ./src/app/alyle-ui-profile/index.js
// module id = 1359
// module chunks = 31